import { Switch, useRouteMatch } from "react-router-dom";
import ProtectedRoute from "components/ProtectedRoutes";
import TradeHistory from "./TradeHistory";
import CompletedTrade from "./CompletedTrade";
// import BuyTraderSession from "./P2pBuyMakePayment";
// import TraderOwnerReleaseSession from "./ReleaseTradeAsset";

import TradeSession from "./TradeSession";

const Trades = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <ProtectedRoute exact path={path} component={TradeHistory} />
      {/* <ProtectedRoute
        path={`${path}/session/:id`}
        component={BuyTraderSession}
      />
      <ProtectedRoute
        path={`${path}/order/:id`}
        component={TraderOwnerReleaseSession}
      /> */}
      <ProtectedRoute path={`${path}/session/:id`} component={TradeSession} />
      {/* <ProtectedRoute path={`${path}/order/:id`} component={TradeSession} /> */}
      <ProtectedRoute
        path={`${path}/completed/:id`}
        component={CompletedTrade}
      />
    </Switch>
  );
};

export default Trades;
